var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import TuneIcon from "@mui/icons-material/Tune";
import { Avatar, Box, Card, CardContent, CardHeader, Divider, Grid, Stack, Typography, } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import React, { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AddActivityMenu } from "../activity/AddActivityMenu";
import { useRetrieveTeamFeed } from "../api/FeedApiProivder";
import { useListAggregatedPlayerStatsByTeam } from "../api/StatsApiProvider";
import { useListTeamHomeVenues } from "../api/TeamVenueApiProvider";
import { useDeleteTeam, useRetrievePlayerByUserId, useRetrievePlayersByTeamId, useRetrieveTeam, useRetrieveTeamPreferences, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { Feed } from "../feed/Feed";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { PlayerView } from "../players/PlayerView";
import { StatsStack } from "../stats/StatsStack";
import { aggregatePlayerStats } from "../stats/utils";
import { SquadCard } from "../teams/SquadCard";
import { TeamColorsCircle } from "../teams/TeamColors";
import { TransferRequestButton } from "../transfer/TransferRequestButton";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { VenuesCard } from "../venues/VenuesCard";
var Team = function () {
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var _a = __read(useState(false), 2), showDelete = _a[0], setShowDelete = _a[1];
    var _b = __read(useState(false), 2), deleteLoading = _b[0], setDeleteLoading = _b[1];
    var _c = useRetrieveUserTeamPermissions({ teamId: id }), userTeamPermissions = _c.data, userTeamPermissionsIsLoading = _c.isLoading, userTeamPermissionsError = _c.error;
    var _d = userTeamPermissions || {}, _e = _d.canModify, canModify = _e === void 0 ? false : _e, _f = _d.canView, canView = _f === void 0 ? false : _f, _g = _d.canViewManager, canViewManager = _g === void 0 ? false : _g, _h = _d.canSubmitTransferRequest, canSubmitTransferRequest = _h === void 0 ? false : _h;
    var _j = useRetrieveTeam({ id: id, enabled: canView }), isTeamLoading = _j.isLoading, error = _j.error, team = _j.data;
    var _k = useRetrievePlayerByUserId({
        userId: (team === null || team === void 0 ? void 0 : team.createdBy) ? Number(team.createdBy) : undefined,
        enabled: canViewManager,
    }), isManagerLoading = _k.isLoading, managerError = _k.error, manager = _k.data;
    var _l = useRetrieveTeamFeed({
        team: team,
        limit: 10,
    }), teamFeed = _l.data, teamFeedIsLoading = _l.isLoading, teamFeedError = _l.error, fetchNextPage = _l.fetchNextPage, hasNextPage = _l.hasNextPage, isFetchingNextPage = _l.isFetchingNextPage;
    var _m = useListAggregatedPlayerStatsByTeam({ teamId: id }), aggregatedStats = _m.data, aggregatedStatsIsLoading = _m.isLoading, aggregatedStatsError = _m.error;
    var filteredAggregatedStats = useMemo(function () {
        if (!aggregatedStats)
            return [];
        return aggregatePlayerStats(aggregatedStats, {
            years: [],
            types: [],
        });
    }, [aggregatedStats]);
    var _o = useRetrieveTeamPreferences({ teamId: id }), teamPreferencesIsLoading = _o.isLoading, teamPreferencesError = _o.error, teamPreference = _o.data;
    var _p = useListTeamHomeVenues({
        teamId: id,
        enabled: canView,
    }), isTeamVenuesLoading = _p.isLoading, teamVenuesError = _p.error, teamVenues = _p.data;
    var _q = useRetrievePlayersByTeamId({ teamId: id }), playersIsLoading = _q.isLoading, playersError = _q.error, players = _q.data;
    var mutation = useDeleteTeam({
        id: id,
        onMutate: function () {
            setDeleteLoading(true);
        },
        onSuccess: function () {
            navigate("/teams/");
        },
        onError: function () { return setDeleteLoading(false); },
    });
    var isLoading = (isTeamLoading && canView) ||
        isTeamVenuesLoading ||
        deleteLoading ||
        teamFeedIsLoading ||
        playersIsLoading ||
        teamPreferencesIsLoading ||
        aggregatedStatsIsLoading ||
        (isManagerLoading && canViewManager);
    var handleDelete = function () {
        mutation.mutate();
    };
    if (userTeamPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userTeamPermissionsError) {
        return _jsx(ErrorView, { error: userTeamPermissionsError });
    }
    if (teamVenuesError) {
        return _jsx(ErrorView, { error: teamVenuesError });
    }
    if (!canView) {
        return _jsx(Forbidden, {});
    }
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (error ||
        playersError ||
        teamPreferencesError ||
        aggregatedStatsError ||
        players === undefined ||
        teamFeedError ||
        managerError ||
        !teamFeed ||
        !team ||
        !teamPreference) {
        return _jsx(ErrorView, { error: error });
    }
    if (teamVenues === undefined) {
        return _jsx(ErrorView, { error: "Failed to load team venues." });
    }
    if (id === undefined) {
        return _jsx(NotFound, {});
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to delete team. Please try again.", onClose: function () { } }), _jsx(DeleteDialog, { open: showDelete, title: "Delete ".concat(team.name, "?"), onCancel: function () { return setShowDelete(false); }, onConfirm: handleDelete }), _jsx(Card, { sx: { mb: 3 }, children: _jsx(CardHeader, { avatar: _jsx(Avatar, { sx: { width: 56, height: 56 }, src: team.logo || "", alt: team.name }), title: _jsx(Typography, { variant: "h5", component: "div", children: team.name }), subheader: _jsxs(Typography, { variant: "caption", fontStyle: "italic", children: [team.nickname, " EST \u2022 ", team.establishedYear] }), action: _jsxs(Stack, { direction: "row", flexWrap: "wrap", spacing: 1, children: [canSubmitTransferRequest && (_jsx(TransferRequestButton, { team: team })), canModify && (_jsxs(_Fragment, { children: [_jsx(Link, { to: "/teams/".concat(id, "/edit/"), children: _jsx(IconButton, { "aria-label": "edit", children: _jsx(EditIcon, {}) }) }), _jsx(Link, { to: "/teams/".concat(team.id, "/preferences/edit/"), children: _jsx(IconButton, { "aria-label": "preferences", children: _jsx(TuneIcon, {}) }) }), _jsx(IconButton, { "aria-label": "delete", onClick: function () { return setShowDelete(true); }, children: _jsx(DeleteIcon, {}) })] }))] }) }) }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, md: 3, order: { xs: 3, md: 1 }, children: _jsx(StatsStack, { stats: filteredAggregatedStats }) }), _jsx(Grid, { item: true, xs: 12, md: 6, order: { xs: 2, md: 2 }, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: true, children: _jsx(Typography, { variant: "h6", children: "Latest Activity" }) }), _jsx(Grid, { item: true, children: canModify && (_jsx(Box, { display: "flex", justifyContent: "flex-end", children: _jsx(AddActivityMenu, { teamId: team.id }) })) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Feed, { feed: teamFeed, fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isFetchingNextPage: isFetchingNextPage }) })] }) }), _jsx(Grid, { item: true, xs: 12, md: 3, order: { xs: 1, md: 3 }, children: _jsxs(Stack, { spacing: 2, children: [_jsx(VenuesCard, { venues: teamVenues
                                        .filter(function (tv) { return tv.isActive; })
                                        .map(function (tv) { return tv.venue; }), canModify: canModify, title: "Home Stadiums", manageUrl: "/teams/".concat(id, "/venues/") }), canViewManager && manager && (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", children: "Manager" }), _jsx(Divider, { sx: { marginBottom: 2 } }), _jsx(PlayerView, { player: manager, variant: "subtitle1" })] }) })), _jsx(SquadCard, { title: _jsx(Typography, { variant: "h6", children: "Squad" }), action: canModify ? (_jsx(Link, { to: "/teams/".concat(team.id, "/add-player/"), children: _jsx(IconButton, { "aria-label": "add-player", children: _jsx(AddIcon, {}) }) })) : undefined, players: players }), _jsxs(Card, { children: [_jsx(CardHeader, { title: _jsx(Typography, { variant: "h6", children: "Team Colors" }) }), _jsxs(CardContent, { children: [_jsx(Divider, { sx: { marginBottom: 2 } }), _jsxs(Stack, { spacing: 2, alignItems: "center", children: [_jsx(Box, { sx: {
                                                                width: "100%",
                                                                maxWidth: 150,
                                                                aspectRatio: "1",
                                                                borderRadius: "50%",
                                                                border: "2px solid",
                                                                borderColor: "divider",
                                                                overflow: "hidden",
                                                                boxShadow: 1,
                                                            }, children: _jsx(TeamColorsCircle, { color1: team.primaryColour, color2: team.secondaryColour }) }), _jsxs(Stack, { direction: "row", spacing: 4, justifyContent: "center", children: [_jsxs(Stack, { spacing: 0.5, alignItems: "center", children: [_jsx(Box, { sx: {
                                                                                width: 24,
                                                                                height: 24,
                                                                                borderRadius: "4px",
                                                                                bgcolor: team.primaryColour,
                                                                                border: "1px solid",
                                                                                borderColor: "divider",
                                                                            } }), _jsx(Typography, { variant: "caption", children: "Primary" })] }), _jsxs(Stack, { spacing: 0.5, alignItems: "center", children: [_jsx(Box, { sx: {
                                                                                width: 24,
                                                                                height: 24,
                                                                                borderRadius: "4px",
                                                                                bgcolor: team.secondaryColour,
                                                                                border: "1px solid",
                                                                                borderColor: "divider",
                                                                            } }), _jsx(Typography, { variant: "caption", children: "Secondary" })] })] })] })] })] })] }) })] })] }));
};
export default Team;
